<template>
  <AboutUs />
</template>

<script lang="ts">
import type { MetaInfo } from 'vue-meta';
import { defineComponent } from '@nuxtjs/composition-api';
import AboutUs from '@/components/partials/landings/about-us/AboutUs.vue';

export default defineComponent({
  name: 'AboutUsPage',
  components: {
    AboutUs,
  },
  layout: 'clear',
  colorMode: 'dark',
  head(): MetaInfo {
    return {
      title: 'About Bravado Company',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Whether you’re an SDR trying to get promoted to AE, or a seasoned VP of Sales needing an executive network to support you, Bravado offers resources to help sales professionals be successful',
        },
      ],
    };
  },
});
</script>
